/* Mobile edge/overscroll paint. This samples CSS surfaces, never video pixels,
   and does not resize the viewport, intercept scrolling or create a renderer. */
(() => {
  const root = document.documentElement;
  const mobile = matchMedia('(pointer: coarse)');
  const tint = document.querySelector('meta[name="theme-color"]');
  const ignored = '.obj-header-stack, .site-grain, canvas, cart-drawer, [role="dialog"], .obj-hero-wordmark-layer, [data-back-to-top], [data-scroll-down]';
  let frame = 0;

  function surfaceColour() {
    const palette = getComputedStyle(root);
    const viewport = window.visualViewport;
    const x = (viewport?.offsetLeft || 0) + (viewport?.width || innerWidth) / 2;
    const y = (viewport?.offsetTop || 0) + 1;
    for (const element of document.elementsFromPoint(x, y)) {
      if (element === root || element === document.body || element.closest(ignored)) continue;
      for (let node = element; node && node !== document.body; node = node.parentElement) {
        const colour = getComputedStyle(node).backgroundColor;
        const channels = colour.match(/[\d.]+/g);
        if (channels?.length >= 3 && (channels.length === 3 || Number(channels[3]) >= .99)) return colour;
      }
    }
    return palette.getPropertyValue('--obj-page-bg').trim();
  }

  function paint() {
    frame = 0;
    if (getComputedStyle(root).getPropertyValue('--obj-native-page-canvas').trim() === '1') {
      // CSS opts native iOS document pages into body-to-canvas propagation.
      // Clear the theme hint so Safari does not tint its status bar and
      // controls with a fixed colour over the content scrolling behind them.
      root.style.removeProperty('--obj-viewport-bg');
      if (tint && tint.content) tint.content = '';
      return;
    }
    if (!mobile.matches) {
      root.style.removeProperty('--obj-viewport-bg');
      if (tint) tint.content = getComputedStyle(root).getPropertyValue('--obj-page-bg').trim();
      return;
    }
    const locked = root.classList.contains('obj-mobile-scroll-locked');
    const colour = locked ? getComputedStyle(root).getPropertyValue('--obj-scene-bg').trim() : surfaceColour();
    const background = locked ? 'var(--obj-scene-bg)' : colour;
    if (root.style.getPropertyValue('--obj-viewport-bg') !== background) root.style.setProperty('--obj-viewport-bg', background);
    // A hint for browsers that honour this; Safari owns its toolbar rendering.
    if (tint && tint.content !== colour) tint.content = colour;
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(paint);
  }
  addEventListener(window.ObjectivScroll ? 'objectiv:scroll' : 'scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  addEventListener('pageshow', schedule);
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  document.addEventListener('objectiv:color-mode-change', () => {
    if (frame) cancelAnimationFrame(frame);
    paint();
  });
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  schedule();
})();
